import { useLocation, useParams, useRouteError } from 'react-router'
import { ErrorBoundary } from '#/components/error-boundary'
import { Head } from '#/components/head'
import { Button } from '#/components/ui/button'
import { Separator } from '#/components/ui/separator'
import { Heading } from '#/components/ui/typography'


export default function PersonalKeycardError() {
  const params = useParams() as { personalKeycardId: string }
  const { state } = useLocation()
  const error = useRouteError()

  // Display name might be available from nav state
  const personalKeycardName = state?.name ?? params.personalKeycardId

  return (
    <div className="flex grow flex-col gap-4 items-start">

      <Head title={personalKeycardName} />

      <div className="flex w-full items-end justify-between gap-4">
        <Heading>{personalKeycardName}</Heading>
        <Button className="invisible" />
      </div>

      <Separator />

      <ErrorBoundary error={error} />

    </div>
  )
}
